import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Box, Card, CardHeader } from '@mui/material';
// utils
//import { fShortenNumber } from '../../utils/formatNumber';
//
import { BaseOptionChart } from './BaseOptionChart';
import { useTheme } from '@mui/material/styles';

//import faker from 'faker';
// ----------------------------------------------------------------------

const CHART_DATA = [
   //data: [6.4, 7.3, 7.7, 8.1, 8.3, 9.2, 9.9] 
        {  name: 'Dor (EVA)',
          data: [6.4, 7.3, 7.7, 8.1, 8.3, 9.2, 9.9]
        }, {
          name: 'Esforço (Borg)',
          data: [2.4, 4.3, 5.7, 7.1, 9.3, 3.2, 4.9]
        }
];

export default function DorEsforcoExercicios() {
    const theme = useTheme();

  const chartOptions = merge(BaseOptionChart(), {
    colors: [
        theme.palette.chart.red[0],
        theme.palette.warning.main
      ],
    
    plotOptions: {
      bar: { 
            horizontal: true,
            barHeight: '70%',
            borderRadius: 4
          }
    },
    xaxis: {
      categories: [
        'Elevação da Cervical', 'Exercicio 4321', 'Rodar a Cabeça',['Flexão Lateral','Isométrica'],['Alongamento dos','Peitorais'],['Mobilização da','Escápula'],'Posição de Prece'
      ],
      labels: {
        formatter: function (val) {
          return val
        }
      },/*
      title: {
        text: "Escala de Borg / Eva"
      },*/
    },
    
    tooltip: {
      y: {
        formatter: function (val) {
          return val
        }
      }
    },
    fill: {
      opacity: 1
    },
      chart: {
      type: 'bar',
      //height: 50,
        stacked: false,
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      offsetX: 100
    }
  });

  return (
    <Card>
      <CardHeader title="Dor e Esforço nos Exercícios" subheader="Média das auto-avaliações dos utentes" />
      <Box sx={{ mx: 1.5 }} dir="ltr">
        <ReactApexChart type="bar" series={CHART_DATA} options={chartOptions} height={300} />
      </Box>
    </Card>
  );
}
